import { render, staticRenderFns } from "./OnceButton.vue?vue&type=template&id=7acabead"
import script from "./OnceButton.vue?vue&type=script&lang=js"
export * from "./OnceButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports